const directionConfig = {
  min: 0,
  max: 360,
}

const rollConfig = {
  min: -90,
  max: 90,
  step: 1,
}

const distanceConfig = {
  min: 1,
  max: 1000,
}

const horizontalConfig = {
  min: 1,
  max: 90,
}

const verticalConfig = { ...horizontalConfig }

const DIRECTION = 'direction'
const ROLL = 'roll'
const DISTANCE = 'distance'
const HORIZONTAL = 'horizontal'
const VERTICAL = 'vertical'
const FLOOR = 'floor'
const AIR = 'air'
const MODEL_GLB = 'modelGlb'
const curParam = {
  direction: 0,
  roll: 90,
  distance: 100,
  horizontal: 45,
  vertical: 45,
}
export {
  directionConfig,
  rollConfig,
  distanceConfig,
  horizontalConfig,
  verticalConfig,
  DIRECTION,
  ROLL,
  DISTANCE,
  HORIZONTAL,
  VERTICAL,
  FLOOR,
  AIR,
  MODEL_GLB,
  curParam,
}
